/* eslint-disable no-useless-escape */
import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import i18n from '../../../assets/i18n';
import { TextMessageBubbleStyled } from './styled';

// === WhatsApp-like formatting engine ===
function formatWhatsAppText(text) {
  if (!text) return '';

  let t = text;

  // ``` multiline pre ```
  t = t.replace(/```([\s\S]*?)```/g, '<pre>$1</pre>');

  // `inline code`
  t = t.replace(
    /(^|[^a-zA-Z0-9])`([^`]+?)`([^a-zA-Z0-9]|$)/g,
    '$1<code>$2</code>$3'
  );

  // *bold*
  t = t.replace(
    /(^|[^a-zA-Z0-9])\*([^*]+?)\*([^a-zA-Z0-9]|$)/g,
    '$1<strong>$2</strong>$3'
  );

  // _italic_
  t = t.replace(
    /(^|[^a-zA-Z0-9])_([^_]+?)_([^a-zA-Z0-9]|$)/g,
    '$1<em>$2</em>$3'
  );

  // ~strike~
  t = t.replace(
    /(^|[^a-zA-Z0-9])~([^~]+?)~([^a-zA-Z0-9]|$)/g,
    '$1<del>$2</del>$3'
  );

  // replace newlines with <br> (WhatsApp behavior)
  t = t.replace(/\n/g, '<br>');

  return t;
}

const TextMessageBubble = ({
  colorClass,
  message,
  date,
  sendType,
  statusIcon,
  deletedIcon,
  errorIcon,
  italic,
}) => {
  const formattedMessage = formatWhatsAppText(message || '');

  return (
    <TextMessageBubbleStyled
      colorClass={colorClass}
      isThereErrorIcon={!_.isNil(errorIcon)}
      sendType={sendType}
    >
      {errorIcon && (
        <div
          className="error-icon-holder"
          data-offset="{'left': 5}"
          data-tip={i18n.errors.tooltipError}
        >
          {errorIcon}
        </div>
      )}

      <div className={colorClass}>
        {deletedIcon ? (
          <div className="deleted-info-holder">
            {deletedIcon}
            <p
              className="deleted-text"
              dangerouslySetInnerHTML={{ __html: formattedMessage }}
            />
          </div>
        ) : (
          <>
            <p
              className={`message-text${italic ? ' message-text--italic' : ''}`}
              dangerouslySetInnerHTML={{ __html: formattedMessage }}
            />

            <div className="info-row">
              <p className="timespan-message">{date}</p>
              {statusIcon}
            </div>
          </>
        )}
      </div>
    </TextMessageBubbleStyled>
  );
};

TextMessageBubble.propTypes = {
  colorClass: PropTypes.string,
  date: PropTypes.string,
  deletedIcon: PropTypes.any,
  errorIcon: PropTypes.any,
  italic: PropTypes.bool,
  message: PropTypes.string,
  sendType: PropTypes.string,
  statusIcon: PropTypes.any,
};

export default TextMessageBubble;
